<template>
  <div class="d-flex w-100 h-100">
    <div class="dashboard-card w-100 flex-row-layout">
      
      <!-- Lado Esquerdo: Titles e Icone -->
      <div class="metric-title-section">
        <div class="icon-orb bg-primary-subtle text-primary mb-2">
            <i class="bi bi-gear-wide-connected"></i>
        </div>
        <h3 class="metric-title">Operação</h3>
        <p class="metric-subtitle">Volume Realizado</p>
      </div>

      <!-- Lado Direito: Datapoints -->
      <div class="metric-data-section">
        
        <div class="data-block">
          <span class="data-label text-muted">Total Sistêmico</span>
          <h4 class="data-value text-dark">{{ totalServices }}</h4>
        </div>

        <div class="data-divider"></div>

        <div class="data-block" :class="{'pulsing': isUpdating}">
          <span class="data-label text-warning-emphasis"><i class="bi bi-clock-history me-1"></i>Aguardando</span>
          <h4 class="data-value text-warning fw-bolder">{{ displayLeftOver }}</h4>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  totalServices: {
    type: Number,
    required: true,
  },
  leftOverService: {
    type: Number,
    required: true,
  },
});

const displayLeftOver = ref(props.leftOverService);
const isUpdating = ref(false);

watch(() => props.leftOverService, (newValue, oldValue) => {
  if (newValue < oldValue) {
    isUpdating.value = true;
    displayLeftOver.value = newValue; 
    setTimeout(() => { isUpdating.value = false; }, 500);
  } else if (newValue !== oldValue) {
    displayLeftOver.value = newValue;
  }
}, { immediate: true });
</script>

<style scoped>
/* V2 Dashboard Card Integration */
.dashboard-card {
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0,0,0,0.02);
  transition: box-shadow 0.2s ease;
  min-height: 120px;
}
.dashboard-card:hover {
  box-shadow: 0 8px 16px rgba(0,0,0,0.05);
}

.flex-row-layout {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

/* Esquerda: Identidade da metrica */
.metric-title-section {
  padding: 1.25rem 1.5rem;
  background: #F8FAFC;
  border-right: 1px dashed #E2E8F0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 140px;
}

.icon-orb {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.bg-primary-subtle { background-color: #EFF6FF; }
.text-primary { color: #3B82F6; }

.metric-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  color: #0F172A;
}
.metric-subtitle {
  margin: 0;
  font-size: 0.8rem;
  color: #64748B;
  font-weight: 500;
}

/* Direita: Numeros */
.metric-data-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 1rem;
}

.data-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.data-divider {
  width: 1px;
  height: 60%;
  background-color: #E2E8F0;
}

.data-label {
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.data-value {
  margin: 0;
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 1;
}

.text-warning-emphasis { color: #D97706; }
.text-warning { color: #F59E0B; }
.text-dark { color: #1E293B; }

/* Feedback Animation */
.pulsing {
  animation: metrics-pulse 0.5s ease-out forwards;
}

@keyframes metrics-pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.15); color: #10B981; }
  100% { transform: scale(1); }
}

@media (max-width: 500px) {
    .flex-row-layout { flex-direction: column; }
    .metric-title-section { border-right: none; border-bottom: 1px dashed #E2E8F0; align-items: center; text-align: center; }
}
</style>